import aboutImg from '../assets/home/about.svg';
import aboutFillImg from '../assets/home/about-fill.svg';
import experienceImg from '../assets/home/expereince.svg';
import experienceFillImg from '../assets/home/experience-fill.svg';
import projectImg from '../assets/home/project.svg';
import projectFillImg from '../assets/home/project-fill.svg';
import skillImg from '../assets/home/skill.svg';
import skillFillImg from '../assets/home/skill-fill.svg';
import certificateImg from '../assets/home/certificate.svg';
import certificateFillImg from '../assets/home/certificate-fill.svg';
import contactImg from '../assets/home/contact.svg';
import contactFillImg from '../assets/home/contact-fill.svg';
import profileImg from '../assets/about/profile_pic.png';

import vaticeImg from '../assets/experience/vatic.png';
import jungleworkImg from '../assets/experience/jungleworks_logo.jpeg';
import hummingbirdImg from "../assets/experience/hummingbird.jpeg";
import amazonImg from '../assets/experience/amazon.png';
import viewzenImg from '../assets/experience/viewzen.jpeg';

import polyglotVideo from "../assets/project/polyglot-updated.mov";
import polyglotGif from "../assets/project/polyglot-gif.gif";
import chatVideo from "../assets/project/chat-demo.mov";
import ecommerceVideo from "../assets/project/ecommerce.mov";

import nptel from "../assets/certification/NPTEL_Programming In Java.jpg";
import courseraOS from "../assets/certification/os.png";
import courseraML1 from "../assets/certification/ml1.png";
import courseraML2 from "../assets/certification/ml2.png";
import courseraML3 from "../assets/certification/ml3.png";
import python1 from "../assets/certification/python.png";
import python2 from "../assets/certification/python2.png";
import algorithm1 from "../assets/certification/mathematical_thinking.png";
import algorithm2 from "../assets/certification/algorithm.png";
import webDev from "../assets/certification/js,html,css.png";
import covid from "../assets/certification/covid-19.png";
import ds from "../assets/certification/DS.png";
import rpa from "../assets/certification/RPA.png";
import ml from "../assets/certification/ML.png";
import js from "../assets/certification/JS.png";
import iot from "../assets/certification/IoT.png";
import math from "../assets/certification/math.png";
import kubernets from "../assets/certification/kubernets.png";

export const menuAssets = {
    about: aboutImg,
    experience: experienceImg,
    project: projectImg,
    skill: skillImg,
    certificate: certificateImg,
    contact: contactImg,
}

export const menuFillAssets = {
    about: aboutFillImg,
    experience: experienceFillImg,
    project: projectFillImg,
    skill: skillFillImg,
    certificate: certificateFillImg,
    contact: contactFillImg,
}

export const aboutAssets = {
    profile: profileImg,
}

export const experienceAssets = {
    vatice: vaticeImg,
    junglework: jungleworkImg,
    hummingbird: hummingbirdImg,
    amazon: amazonImg,
    viewzen: viewzenImg,
}

export const projectAssets = {
    polyglotVideo: polyglotVideo,
    polyglotGif: polyglotGif,
    chatVideo: chatVideo,
    ecommerceVideo: ecommerceVideo,
}

export const certificateAssets = {
    nptel: nptel,
    courseraOS: courseraOS,
    courseraML1: courseraML1,
    courseraML2: courseraML2,
    courseraML3: courseraML3,
    python1: python1,
    python2: python2,
    algorithm1: algorithm1,
    algorithm2: algorithm2,
    webDev: webDev,
    covid: covid,
    ds: ds,
    rpa: rpa,
    ml: ml,
    js: js,
    iot: iot,
    math: math,
    kubernets: kubernets,
}
